import { AfterContentInit, ContentChildren, Directive, OnDestroy, output, OutputRefSubscription, QueryList } from '@angular/core';
import { ValidatorDirective } from '@shared/validator.directive';

/** checks all children with a ValidatorDirective Directive and outputs (formValid) when any values change */
@Directive({
  selector: '[formValidator]',
  standalone: true,
})
export class FormValidValidatorDirective implements AfterContentInit, OnDestroy {
  public readonly formValid = output<boolean>();

  @ContentChildren(ValidatorDirective, { descendants: true })
  validators!: QueryList<ValidatorDirective>;

  private readonly subs: OutputRefSubscription[] = [];
  private readonly state: Map<ValidatorDirective, boolean> = new Map();

  ngAfterContentInit(): void {
    this.validators.forEach(v => {
      this.state.set(v, true);
      const sub = v.isValid.subscribe(valid => {
        this.state.set(v, valid);
        this.emitOverall();
      });
      this.subs.push(sub);
    });

    this.emitOverall();
  }

  private emitOverall(): void {
    const allValid = Array.from(this.state.values()).every(v => v);
    this.formValid.emit(allValid);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
